module.exports = __webpack_public_path__ + "static/CI_Logo_4c_2018_white-0feeab48ba3fa81405669d16976daecc.png";